import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { ExportDialogTypeEnum } from '../export-dialog.types';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var ExportDialogService = /** @class */ (function () {
    function ExportDialogService(apollo) {
        var _a, _b;
        this.apollo = apollo;
        this.inputWhereNameMap = (_a = {},
            _a[ExportDialogTypeEnum.users] = 'userWhere',
            _a[ExportDialogTypeEnum.groups] = 'groupWhere',
            _a[ExportDialogTypeEnum.locations] = 'locationWhere',
            _a[ExportDialogTypeEnum.equipments] = 'equipmentWhere',
            _a[ExportDialogTypeEnum.quotations] = 'quotationWhere',
            _a[ExportDialogTypeEnum.recurrences] = 'recurrenceWhere',
            _a[ExportDialogTypeEnum.maintenances] = 'maintenanceWhere',
            _a[ExportDialogTypeEnum.maintenancesImr] = 'maintenanceImrWhere',
            _a[ExportDialogTypeEnum.productsServices] = 'productServiceWhere',
            _a[ExportDialogTypeEnum.formAnswers] = 'dashboardFormsAnswersDetailWhere',
            _a[ExportDialogTypeEnum.productsServicesTopCompanies] = 'dashboardProductsServicesTopCompaniesWhere',
            _a);
        this.inputIncludesNameMap = (_b = {},
            _b[ExportDialogTypeEnum.locations] = 'locationInclude',
            _b);
    }
    ExportDialogService.prototype.createExport = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo
                            .query({
                            query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          mutation createExport($input: CreateExportInput!) {\n            createExport(input: $input) {\n              id\n            }\n          }\n        "], ["\n          mutation createExport($input: CreateExportInput!) {\n            createExport(input: $input) {\n              id\n            }\n          }\n        "]))),
                            variables: {
                                input: input
                            }
                        })
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportDialogService.prototype.toCreateExportParams = function (_a) {
        var _b;
        var type = _a.type, where = _a.where, include = _a.include;
        var params = (_b = {
                type: type,
                language: navigator.language || 'pt-BR',
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            _b[this.inputWhereNameMap[type]] = where || null,
            _b);
        if (this.inputIncludesNameMap[type]) {
            params[this.inputIncludesNameMap[type]] = include || null;
        }
        return params;
    };
    ExportDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExportDialogService_Factory() { return new ExportDialogService(i0.ɵɵinject(i1.Apollo)); }, token: ExportDialogService, providedIn: "root" });
    return ExportDialogService;
}());
export { ExportDialogService };
var templateObject_1;
